import { FormSignProcessControllerService } from './../../../../sdk/services/form-sign-process-controller.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzShowUploadList, NzUploadFile } from 'ng-zorro-antd/upload';
import { FormSignControllerService } from 'src/app/sdk/services/form-sign-controller.service';
import { MinioControllerService } from 'src/app/sdk/services/minio-controller.service';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';
import { VwFindMyFormService } from 'src/app/shared/service/api/vw-find-my-form.service';
import { BASE_DATA_FORM, EDICT_DATA_FORM } from './constant/base-data';
import { NzMessageService } from 'ng-zorro-antd/message';
import { VwFindSigndataControllerService } from 'src/app/sdk/services/vw-find-signdata-controller.service';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { DetailApplicationService } from './service/detail-application.service';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { BidInfo } from './component/make-budget-estimates/interface/budget-estimates';
import { TranslateService } from '@ngx-translate/core';
import { MatomoTracker } from 'ngx-matomo';
@Component({
  selector: 'app-detail-application',
  templateUrl: './detail-application.component.html',
  styleUrls: ['./detail-application.component.scss']
})
export class DetailApplicationComponent implements OnInit {
  name: string | undefined;
  url: string | undefined;
  formid: string | undefined;

  baseDataStatus: boolean = false;//是否显示基础资料UI 工程分类UI 描述与详情UI
  taskAssignStatus: boolean = false;//是否显示厂务课级签核UI:工程分类明细  派单厂务工程师 选择厂商
  appAppointStatus: boolean = false;//是否显示预约厂商UI:预约厂商查看现场与标单信息
  sendOrderStatus: boolean = false;//是否显示签核记录UI
  assignStatus: boolean = false;//是否显示审核结果UI
  makeBidStatus: boolean = false;//是否显示厂商标单制定UI:标单制定
  makeBudgetEstimatesStatus: boolean = false;//是否显示厂务概算制定UI:专案分类 标单概算制定
  reviewResultStatus: boolean = false;//是否显示审核结果UI
  uploadQuotationStatus: boolean = false;//是否显示报价单上传UI
  uploadQuotationEditStatus: boolean = false;//是否可编辑报价单上传UI
  PRPOInfoStatus: boolean = false;//是否PRPOInfo UI
  // submitButtonStatus = true;//是否显示单据详情的编辑和取消按钮
  btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
    submitCancelReture: false,
    submitReture: false,
    cancelReture: false,
    reture: false,
  }

  // isEditrEquireDocs: boolean = true;
  isEditStatus: boolean = false;
  isEdit: boolean = false;//是否為編輯狀態,flase不可編輯，true可編輯
  taskAssignEdictStatus: boolean = false;//厂务课级签核部分是否为可编辑
  vendorTaskAssignEdictStatus = false;//厂务课级签核中的选择厂商部分是否可编辑;false:可编辑
  engineerTaskAssignEdictStatus = false;//厂务课级签核中的厂务工程师部分是否可编辑;false:可编辑
  taskAssignDisabled: boolean = false;//和vendorTaskAssignEdictStatus共同控制厂务课级签核的可编辑内容

  appointEditStatus = false;//预约厂商是否可编辑
  makeBidEditStatus = false;//厂商标单制定是否可编辑
  editBudgetEstimatesStatus = false;//厂务概算制定是否可编辑
  reviewResultIsReject = false;//厂务概算制定被驳回后的UI界面(没有下载等功能)
  isDownLoadBid = false;//是否可下载标单/概算(厂务工程师/课级/部级/助理可下载)


  maxVersionNum: number;//单据最大版本号

  editBtnName = "Common.Submit";
  cancelBtnName = "Common.Cancel";
  returnBtnName = "Common.Back";
  isCancel = false;
  cancelReason = "";
  activeBtn: string;
  num: number;
  // userid: string;//当前登录账户
  signStepEmplid: string;//当前签核步骤的签核人账号
  DetailData = { ...BASE_DATA_FORM };
  historyDetailData = { ...BASE_DATA_FORM };
  electromechanical: boolean = false;
  civilEngineering: boolean = false;
  historyElectromechanical: boolean = false;
  historyCiviEngineering: boolean = false;
  step: number;
  edictData = { EDICT_DATA_FORM };
  imageList: NzUploadFile[] = [];
  fileList: NzUploadFile[] = [];
  imageArr = [];
  title = '';
  isVisible = false;
  versionArr = [];
  modalTitle = "";
  nzModal = true;
  assignStatusData = {};//审核结果data:step1,2,3,4,5
  reviewResultStatusData = {};//审核结果data:step:6,7...


  confirmModal?: NzModalRef;
  // 是否显示现况区域照片及上传需求方案的上传按钮
  nzShowButton = false;
  // 待签核的单据要隐藏描述与详情中的图片和文件上传的删除图标
  nzShowUploadList: NzShowUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: false,
    showDownloadIcon: true,
  };
  isEditImage: boolean = true;// true:可修改图片;false:不可修改图片

  // 除询价外都要隐藏报价单上传中的文件上传的删除图标
  nzShowUploadListOfUploadQuotation: NzShowUploadList = {
    showPreviewIcon: false,
    showRemoveIcon: false,
    showDownloadIcon: true,
  };
  nzShowButtonOfUploadQuotation: boolean = false;//是否显示报价单上传的上传按钮

  nzSpinning = false;

  submitTaskAssignData = {};//厂务签核提交的数据
  submitAppointTaskData = {};//预约厂商提交的数据
  submitActualTaskData = {};//实际厂商到现场的提交的数据
  assignPhone: string;//预约厂商中填写的派单厂务工程师的手机号
  getAssignPhone: string;
  bidSaveData = {};//标单制定保存的数据
  submitBidSaveData = {};//标单制定submit的数据
  submitQuotationInfo = {};//报价单上传Info

  //概算制定保存的数据
  budgetSaveData = {};
  //概算制定submit的数据
  submitBudgetSaveData = {};
  projectCategory: number;//专案分类
  getProjectCategory: number;//专案分类
  formBudgetCharge = {};//预算编码 挂账部门 厂别
  getFormBudgetCharge = {};//DB中的预算编码和挂账部门


  constructor(
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private vwFindMyFormService: VwFindMyFormService,
    private minioService: MinioControllerService,
    private message: NzMessageService,
    private formSignProcessService: FormSignProcessControllerService,
    private lb4ApiService: Lb4ApiService,
    private vwFindSigndata: VwFindSigndataControllerService,
    private fromSignService: FormSignControllerService,
    private modal: NzModalService,
    private detailApplicationService: DetailApplicationService,
    private commonService: CommonService,
    private translateService: TranslateService,
    private matomoTracker: MatomoTracker
  ) {
    this.activatedRoute.queryParams.subscribe(queryParams => {
      this.name = queryParams.name;
      this.url = queryParams.url;
      this.formid = queryParams.formid;
      this.activeBtn = queryParams.activeBtn;
      this.step = queryParams.step ? queryParams.step : 0;
      this.signStepEmplid = queryParams.signStepEmplid;
    });
  }

  async ngOnInit() {
    this.matomoTracker.trackPageView('單據詳情');
    this.step = Number(this.step);
    console.log("this.formid", this.formid, "this.signStepEmplid", this.signStepEmplid, "this.step", this.step, "this.name", this.name, "this.activeBtn", this.activeBtn);
    // 最大版本号
    this.maxVersionNum = await this.commonService.getMaxVersion(this.formid);

    // 获取厂务工程师联系方式(询价-已取消的step=2,所以不能写在step>3的时候执行)
    await this.getDBAssignPhone();
    // 预约厂商及预约厂商之后的step才需要显示派单厂务联系方式
    if (this.step > 3) {
      this.detailApplicationService.sendAssignPhoneData.subscribe(res => {
        this.assignPhone = res;
      });
    }
    if (this.step >= 9) {
      // 获取DB中的预算编码和挂账部门
      this.getInitInquotationInfo();
    }

    let formHead = await this.lb4ApiService.find('form_head', { where: { formId: this.formid } });
    if (formHead[0]['editor'] === this.signStepEmplid) {
      await this.lb4ApiService.updateAll('form_head', { isEdit: 0 }, { formId: this.formid });
    }
    this.title = `${this.translateService.instant(this.activeBtn)}${this.translateService.instant('DetailInfo.sDOC')}`;
    // 我的单据
    if (this.name === "MyDoc") {
      this.baseDataStatus = true;
      this.sendOrderStatus = true;
      this.assignStatus = false;
      this.isEditStatus = true;

      // 是否显示删除按钮
      this.nzShowUploadList.showRemoveIcon = false;
      await this.getInitDeteailData();
    }
    // 申请单位签核
    if (this.name === 'ApplyingUnit') {
      this.baseDataStatus = true;
      this.sendOrderStatus = true;
      this.isEditStatus = false;
      this.assignStatus = true;
      // 项目管理签核this.step === 1
      if (this.step === 1) {
        // 需求描述不可编辑
        this.isEdit = false;
        // 不能上传图片
        this.isEditImage = false;
        this.nzShowButton = true;
        // 是否显示删除按钮
        this.nzShowUploadList.showRemoveIcon = true;
      }
      // 部级签核this.step == 2
      else if (this.step === 2) {
        this.isEditStatus = false;
        this.nzShowUploadList.showRemoveIcon = false;
      }
      //概算签核((this.step === 9 && this.projectCategory === 0) || (this.step === 10 && this.projectCategory === 1))
      else {
        this.baseDataStatus = true;
        this.taskAssignStatus = true;
        this.assignStatus = false;
        this.taskAssignEdictStatus = false;
        this.appAppointStatus = true;
        this.makeBudgetEstimatesStatus = true;
        this.reviewResultStatus = true;
        this.sendOrderStatus = true;
        this.nzShowUploadList.showRemoveIcon = false;
        if (Number(this.step) === 10) {//专案工程:显示报价单上传UI
          this.uploadQuotationStatus = true;
          this.uploadQuotationEditStatus = this.url.includes('factoryinquiryconfig') ? true : false;
        }

      }
    }
    // 厂务签核[3, 7, 8].includes(this.step)
    else if (this.name === "FacilityApproval") {
      if (this.step == 3) {
        this.baseDataStatus = true;
        this.assignStatus = true;
        this.taskAssignStatus = true;
        this.taskAssignEdictStatus = true;
        this.sendOrderStatus = true;
        this.nzShowUploadList.showRemoveIcon = false;
        this.isEdit = true;//在厂务课级待签签核中工程分类可选,因此还要在已签中设置工程分类不可选
      }
      else {
        this.baseDataStatus = true;
        this.taskAssignStatus = true;
        this.taskAssignEdictStatus = false;
        this.assignStatus = false;
        this.appAppointStatus = true;
        this.makeBudgetEstimatesStatus = true;
        this.editBudgetEstimatesStatus = false;
        this.isDownLoadBid = true;
        this.reviewResultStatus = true;
        this.sendOrderStatus = true;
        this.nzShowUploadList.showRemoveIcon = false;
      }

    }
    // 预约厂商step===4
    else if (this.name === "VendorAppointment") {
      this.baseDataStatus = true;
      this.taskAssignStatus = true;
      this.taskAssignEdictStatus = false;
      this.assignStatus = false;
      this.appAppointStatus = true;
      this.appointEditStatus = true;
      this.sendOrderStatus = true;
      this.nzShowUploadList.showRemoveIcon = false;
    }
    // 厂商标单制定step===5
    else if (this.name === "BidCreating") {
      this.baseDataStatus = true;
      this.taskAssignStatus = true;
      this.taskAssignEdictStatus = false;
      this.assignStatus = false;
      this.appAppointStatus = true;
      this.makeBidStatus = true;
      this.makeBidEditStatus = true;
      this.nzShowUploadList.showRemoveIcon = false;
    }
    // 厂务概算制定step===6
    else if (this.name === "Budgeting") {
      this.baseDataStatus = true;
      this.taskAssignStatus = true;
      this.taskAssignEdictStatus = false;
      this.assignStatus = false;
      this.appAppointStatus = true;
      this.makeBudgetEstimatesStatus = true;
      this.editBudgetEstimatesStatus = true;
      this.isDownLoadBid = true;
      this.reviewResultStatus = true;
      this.sendOrderStatus = true;
      this.nzShowUploadList.showRemoveIcon = false;
    }
    // 厂务助理询价((this.step === 9 && this.projectCategory === 1) || (this.step === 10 && this.projectCategory === 0))
    else if (this.name === "FacAssInquiry") {
      this.baseDataStatus = true;
      this.taskAssignStatus = true;
      this.taskAssignEdictStatus = false;
      this.appAppointStatus = true;
      this.makeBudgetEstimatesStatus = true;
      this.isDownLoadBid = true;
      this.sendOrderStatus = true;
      this.uploadQuotationStatus = true;
      this.uploadQuotationEditStatus = false;
      // 显示上传按钮
      this.nzShowButtonOfUploadQuotation = false;
      // 是否显示删除按钮
      this.nzShowUploadListOfUploadQuotation.showRemoveIcon = false;
      //询价
      if (this.activeBtn === "Common.INQUIRY") {
        this.uploadQuotationEditStatus = this.url.includes('factoryinquiryconfig') ? true : false;
        // 显示上传按钮
        this.nzShowButtonOfUploadQuotation = this.url.includes('factoryinquiryconfig') ? true : false;
        // 是否显示删除按钮
        this.nzShowUploadListOfUploadQuotation.showRemoveIcon = this.url.includes('factoryinquiryconfig') ? true : false;
        this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
          submitCancelReture: true,
          submitReture: false,
          cancelReture: false,
          reture: false,
        }
      }
      // 待开PR
      else if (this.activeBtn === "Common.PRPending" || this.step == 11) {
        this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
          submitCancelReture: false,
          submitReture: false,
          cancelReture: true,
          reture: false,
        }
      }
      // PR签核中 下PO 已取消
      else if (["Common.PRApproving", "Common.PORequest", 'Common.Canceled'].includes(this.activeBtn)) {
        this.PRPOInfoStatus = true;
        this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
          submitCancelReture: false,
          submitReture: false,
          cancelReture: false,
          reture: true,
        }
      }
    }
    if (this.isEditStatus === true) {
      // 单据历史版本不能大于3
      if (this.maxVersionNum <= 3) {//变更需求
        this.editBtnName = "Common.ChangeDemands";
      }
    }
    // 进行中 待签核 待预约 待制定 
    if (['Common.OnGoing', 'Common.ToBeApproved', 'Common.AppointmentPending', 'Common.ToBeCreated'].includes(this.activeBtn)) {
      this.num = 0;
      // 待签核 待预约 待制定
      if (['Common.ToBeApproved', 'Common.AppointmentPending', 'Common.ToBeCreated'].includes(this.activeBtn)) {
        this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
          submitCancelReture: false,
          submitReture: true,
          cancelReture: false,
          reture: false,
        }
      }
      // 进行中
      else if (['Common.OnGoing'].includes(this.activeBtn)) {
        this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
          submitCancelReture: true,
          submitReture: false,
          cancelReture: false,
          reture: false,
        }
      }

    }
    // 询价 待开PR PR签核中 下PO
    if (['Common.INQUIRY', 'Common.PRPending', 'Common.PRApproving', 'Common.PORequest'].includes(this.activeBtn)) {
      const currentUrl = location.pathname;// 获取当前url
      this.num = currentUrl.includes('factoryinquiryconfig') ? 0 : 1;
      // 询价
      if (this.activeBtn === 'Common.INQUIRY') {
        this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
          submitCancelReture: true,
          submitReture: false,
          cancelReture: false,
          reture: false,
        }
      }
      else {
        this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
          submitCancelReture: false,
          submitReture: false,
          cancelReture: true,
          reture: false,
        }
      }
    }
    // 已完成
    else if (this.activeBtn === "Common.ApprovalCompleted") {
      this.assignStatus = false;
      this.num = 1;
      this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
        submitCancelReture: false,
        submitReture: false,
        cancelReture: false,
        reture: true,
      }
    }
    // 已取消 厂务助理已取消 已签核 已预约 已制定
    else if (['Common.Canceled', 'Common.FacAssistantCanceled', 'Common.Approved', "Common.AppointmentCompleted", 'Common.Created'].includes(this.activeBtn)) {
      // 我的单据--已取消:-1;厂务助理询价已取消是-4,其他已签核 已预约 已制定是1
      this.num = this.activeBtn === 'Common.Canceled' ? -1 : this.activeBtn === 'Common.FacAssistantCanceled' ? -4 : 1;
      this.assignStatus = false;
      this.appointEditStatus = false;
      this.taskAssignEdictStatus = false;
      this.makeBidEditStatus = false;
      this.editBudgetEstimatesStatus = false;
      this.reviewResultStatus = false;
      this.nzShowUploadList.showRemoveIcon = false;
      this.nzShowButton = false;
      this.isEdit = false;//在所有已签核中工程分类都不可选
      this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
        submitCancelReture: false,
        submitReture: false,
        cancelReture: false,
        reture: true,
      };
      if (this.step == 3) {//任务指派
        this.editBtnName = "Common.Reassign"
        this.num = 1;
        this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
          submitCancelReture: false,
          submitReture: true,
          cancelReture: false,
          reture: false,
        }
      }
    }
    // 已驳回
    else if (['Common.Rejected'].includes(this.activeBtn)) {
      this.appointEditStatus = false;
      this.taskAssignEdictStatus = false;
      // 厂务概算制定--已驳回:可修改标单
      this.editBudgetEstimatesStatus = this.step === 6 ? true : false;
      this.num = this.name === "BidCreating" ? -2 : 2;
      this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
        submitCancelReture: this.step === 0 ? true : false,
        submitReture: this.step === 0 ? false : true,
        cancelReture: false,
        reture: false,
      }
    }

    // 在报表和Ddashboard中打开的单据详情底部功能按钮只显示返回按钮
    const currUrl = location.pathname;//获取当前url
    if (currUrl.includes('/report/') || currUrl.includes('/dashboard/')) {//报表 Ddashboard
      this.btnStatus = {//是否显示单据详情的编辑 取消 返回按钮
        submitCancelReture: false,
        submitReture: false,
        cancelReture: false,
        reture: true,
      }
    }
    await this.getInitDeteailData();
    this.getInintVersins();
  }

  // 提交或变更需求
  async editFn() {
    let formHead = await this.lb4ApiService.find('form_head', { where: { formId: this.formid } });
    if (formHead[0]['editor'] === this.signStepEmplid || formHead[0]['isEdit'] === 0) {
      // 变更需求
      if (this.editBtnName === "Common.ChangeDemands") {
        await this.detailApplicationService.getMaxVersionInitSignOrder(this.formid, this.maxVersionNum, this.civilEngineering, this.electromechanical).then(async res => {
          const typeData = res['civilSignData'].length >= res['eleSignData'].length ? res['civilSignData'] : res['eleSignData'];
          const inquiryArr = this.projectCategory === null ? [] : this.projectCategory === 0 ? typeData.filter(ele => ele.signStep >= 10) : typeData.filter(ele => ele.signStep >= 9);
          //询价及询价后申请人不能再变更需求
          if (inquiryArr.length > 0) {
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.rejectChangeDemandsTip1')}`);
          }
          else {
            // 提交次数不能大于3
            if (this.maxVersionNum < 3) {
              // this.editBtnName从"变更需求"调整成"提交"
              this.editBtnName = "Common.Submit";
              let currentDetailData = JSON.parse(JSON.stringify(this.DetailData));
              this.DetailData = currentDetailData;
              this.isEdit = true;
              this.nzShowButton = true;
              // 变更需求可上传图片
              this.isEditImage = true;
              this.nzShowUploadList.showRemoveIcon = true;
              //用户点击变更需求时，此单子不能做任何编辑
              await this.lb4ApiService.updateAll('form_head', { isEdit: 1, editor: this.signStepEmplid }, { formId: this.formid });
            } else {
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.rejectChangeDemandsTip2')}`);
            }
          }
        });
      }
      // 提交
      else if (this.editBtnName === "Common.Submit") {
        this.nzSpinning = true;
        if (this.name === "MyDoc") {
          // 提交次数不能大于3
          if (this.maxVersionNum < 3) {
            let FormApplyDetailParam = JSON.parse(JSON.stringify(this.DetailData));
            FormApplyDetailParam['applicantId'] = FormApplyDetailParam['emplid'].split(" / ")[1];
            FormApplyDetailParam['formId'] = this.formid;
            delete FormApplyDetailParam['emplid'];
            delete FormApplyDetailParam['name'];
            delete FormApplyDetailParam['applayTime'];
            delete FormApplyDetailParam['version'];
            delete FormApplyDetailParam['datetime'];

            if (FormApplyDetailParam['requireDocs']) {
              FormApplyDetailParam['requireDocs'] = this.dataComparison(JSON.parse(FormApplyDetailParam['requireDocs'] as string),
                this.edictData['requireDocs']);
            }

            if (FormApplyDetailParam['image']) {
              FormApplyDetailParam['image'] = this.dataComparison(JSON.parse(FormApplyDetailParam['image'] as string),
                this.edictData['image']);
            }
            // 之前:FormApplyDetailParam['requireDocs'].length > 0 || FormApplyDetailParam['requireDocs'] != '[]'
            if (JSON.parse(FormApplyDetailParam['requireDocs']).length > 0) {
              let param = {
                image: this.edictData['image'],
                requireDocs: this.edictData['requireDocs'],
                formapplydata: FormApplyDetailParam
              }
              // 提交重新指派后的数据
              this.minioService.reUpdateFileAndDataOnce({ module: "num", body: param }).toPromise().then(async reUpdateResult => {
                if (reUpdateResult[0]['success']) {
                  this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                  this.route.navigate([this.url], { replaceUrl: true });
                  //提交成功,就表示需求已经结束
                } else {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                }
              }).catch(e => {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
              });
            } else {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.myDocRequireDocsTip')}`);
            }
          } else {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.rejectChangeDemandsTip2')}`);
          }
        }
        else if (this.name === "ApplyingUnit") {
          if (this.step === 1) {//申请单位签核--项目管理审核
            // 获取最新的文件
            this.DetailData['requireDocs'] = this.dataComparison(JSON.parse(this.DetailData['requireDocs'] as string), this.edictData['requireDocs']);
            if (this.edictData['requireDocs'] || this.DetailData['requireDocs'] != '[]') {
              let param = {
                requireDocs: this.edictData['requireDocs'],
                oldRequireDocs: this.DetailData['requireDocs'],
                data: this.assignStatusData
              }
              this.fromSignService.updateFileAndSignData({
                module: "num",
                signMan: this.signStepEmplid,
                body: param
              }).toPromise().then(updateResult => {
                if (updateResult['success']) {
                  this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                  this.route.navigate([this.url], { replaceUrl: true });
                } else {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                }
              }).catch(e => {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
              });
            }
            else {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.myDocRequireDocsTip')}`);
            }
          }
          else if (this.step === 2) {//申请单位签核--部级签核
            this.fromSignService.signByMinisterial(
              {
                signMan: this.signStepEmplid,
                module: "num",
                body: this.assignStatusData
              }
            ).toPromise().then(ministerialResult => {
              if (ministerialResult['success']) {
                this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                this.route.navigate([this.url], { replaceUrl: true });
              } else {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
              }
            }).catch(e => {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
            });
          }
          else {//申请单位签核--预算审核
            if ((JSON.stringify(this.formBudgetCharge) === "{}" || !this.formBudgetCharge['budgetCode'] || !this.formBudgetCharge['creditDepartment'] || !this.formBudgetCharge['plant']) && this.reviewResultStatusData['status'] === 1) {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.budgetsApprovalAgreeTip')}`);
            }
            else if (JSON.stringify(this.reviewResultStatusData) === "{}") {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.reviewResultTip')}`);
            }
            else if (this.reviewResultStatusData['status'] === 2 && this.reviewResultStatusData['remark'] === "") {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.reviewResultRejectTip')}`);
            }
            else {
              let formBudgetCharge = {};
              if (this.reviewResultStatusData['status'] === 1) {//同意
                this.reviewResultStatusData['remark'] = "";
                formBudgetCharge = { "formId": this.formid, ...this.formBudgetCharge };
              }
              else {//驳回
                formBudgetCharge = { "formId": "", "budgetCode": "", "creditDepartment": "", "plant": "" };
              }
              const body = {
                "signData": { "formId": this.formid, "status": this.reviewResultStatusData['status'], "remark": this.reviewResultStatusData['remark'], "signStep": Number(this.step) },
                "formBudgetCharge": formBudgetCharge
              }
              this.formSignProcessService.sendBudgetAaudit({ "signMan": this.signStepEmplid, "body": body }).toPromise().then(budgetResult => {
                if (budgetResult[0]['success']) {
                  this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                  this.route.navigate([this.url], { replaceUrl: true });
                } else {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                }
              }).catch(e => {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
              });
            }
          }
        }
        else if (this.name === "FacilityApproval") {
          //任务指派
          if (this.step == 3) {
            // 已签核--重新指派
            if (['Common.Approved'].includes(this.activeBtn)) {
              if ((this.civilEngineering && JSON.stringify(this.submitTaskAssignData['vendorInfoOption']['civilfacture']) === '{}') ||
                (this.electromechanical && JSON.stringify(this.submitTaskAssignData['vendorInfoOption']['electrofacture']) === '{}')) {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.taskAssignmentSelectVendorTip')}`);
              } else {
                const reassignBody = {
                  assignEngineer: this.submitTaskAssignData['assignEngineer'],
                  vendorInfoReoption: this.submitTaskAssignData['vendorInfoOption']
                };
                await this.formSignProcessService.anewAssign({ body: reassignBody })
                  .toPromise().then(anewAssignResult => {
                    if (anewAssignResult[0]['success']) {
                      this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                      this.route.navigate([this.url], { replaceUrl: true });
                    } else {
                      this.nzSpinning = false;
                      this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                    }
                  }).catch(e => {
                    this.nzSpinning = false;
                    this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                  });
              }
            }
            //待签核
            else {
              if (this.assignStatusData['status'] === 2) {//驳回
                if (this.assignStatusData['remark'] === null) {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.reviewResultRejectTip')}`);
                }
                else {
                  //调用任务指派驳回的API
                  const step3SignData = {};
                  step3SignData['projectSort'] = this.submitTaskAssignData['projectSort'];
                  step3SignData['signData'] = this.assignStatusData;
                  await this.formSignProcessService.sendSignResultStep3({ 'signMan': this.signStepEmplid, 'body': step3SignData }).toPromise().then(assignResult => {
                    if (assignResult[0]['success']) {
                      this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                      this.route.navigate([this.url], { replaceUrl: true });
                    } else {
                      this.nzSpinning = false;
                      this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                    }
                  }).catch(e => {
                    this.nzSpinning = false;
                    this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                  });
                }
              }
              else if (this.assignStatusData['status'] === 1) {//同意
                if (JSON.stringify(this.submitTaskAssignData) === '{}') {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.requiredTip')}`);
                }
                else if ((this.civilEngineering && (!this.submitTaskAssignData['civilEngineering']['projectItemInfo'])) ||
                  (this.electromechanical && (!this.submitTaskAssignData['electromechanical']['projectItemInfo']))) {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.selectEngineeringCategoryDetailsTip')}`);
                }
                else if (JSON.stringify(this.submitTaskAssignData['assignEngineer']) === '{}') {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.selectFacEngineeringTip')}`);
                }
                // JSON.stringify(this.submitTaskAssignData['vendorInfoOption']['civilfacture']) === '{}' &&
                // JSON.stringify(this.submitTaskAssignData['vendorInfoOption']['electrofacture']) === '{}'
                else if ((this.civilEngineering && JSON.stringify(this.submitTaskAssignData['vendorInfoOption']['civilfacture']) === '{}') ||
                  (this.electromechanical && JSON.stringify(this.submitTaskAssignData['vendorInfoOption']['electrofacture']) === '{}')) {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.selectVendorTip')}`);
                }
                else {
                  this.submitTaskAssignData['signData'] = this.assignStatusData;
                  await this.formSignProcessService.sendSignResultStep3({ 'signMan': this.signStepEmplid, 'body': this.submitTaskAssignData }).toPromise().then(assignResult => {
                    if (assignResult[0]['success']) {
                      this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                      this.route.navigate([this.url], { replaceUrl: true });
                    } else {
                      this.nzSpinning = false;
                      this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                    }
                  }).catch(e => {
                    this.nzSpinning = false;
                    this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                  });
                }
              }
            }

          }
          else {//标单审核 || 概算审核
            if (JSON.stringify(this.reviewResultStatusData) === "{}") {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.reviewResultTip')}`);
            }
            else if (this.reviewResultStatusData['status'] === 2 && this.reviewResultStatusData['remark'] === "") {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.reviewResultRejectTip')}`);
            }
            else {
              let params = {
                "signMan": this.signStepEmplid,
                "body": {
                  "formId": this.formid,
                  "status": this.reviewResultStatusData['status'],
                  "remark": this.reviewResultStatusData['remark'],
                  "signStep": Number(this.step),
                }
              };
              if (this.step == 7 || this.step == 8) {//课级 || 部级
                await this.formSignProcessService.sendSignResultSeven(params).toPromise().then(sevenResult => {
                  if (sevenResult[0]['success']) {
                    this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                    this.route.navigate([this.url], { replaceUrl: true });
                  } else {
                    this.nzSpinning = false;
                    this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                  }
                }).catch(e => {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                });
              }
            }
          }
        }
        // 预约厂商
        else if (this.name === "VendorAppointment") {
          if (this.assignPhone) {
            let reg = /^\d{4,11}$/;
            if (!(reg.test(this.assignPhone))) {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.phoneTip')}`);
            }
            else if (this.civilEngineering === this.electromechanical
              && (JSON.stringify(this.submitAppointTaskData) === "{}"
                || (JSON.stringify(this.submitAppointTaskData['appointmentManfacturerData']['civilfactureData']) === "{}" ||
                  JSON.stringify(this.submitAppointTaskData['appointmentManfacturerData']['electrofactureData']) === "{}")
                || (Object.keys(this.submitAppointTaskData['appointmentManfacturerData']['civilfactureData']).length < 6 ||
                  Object.keys(this.submitAppointTaskData['appointmentManfacturerData']['electrofactureData']).length < 6))
            ) {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.vendorAppointmentTip')}`);
            }
            else {
              if (JSON.stringify(this.submitAppointTaskData) === "{}"
                || (JSON.stringify(this.submitAppointTaskData['appointmentManfacturerData']['civilfactureData']) === "{}" &&
                  JSON.stringify(this.submitAppointTaskData['appointmentManfacturerData']['electrofactureData']) === "{}")
                || (Object.keys(this.submitAppointTaskData['appointmentManfacturerData']['civilfactureData']).length < 6 &&
                  Object.keys(this.submitAppointTaskData['appointmentManfacturerData']['electrofactureData']).length < 6)
              ) {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.vendorAppointmentTip')}`);
              }
              else {
                this.formSignProcessService.sendSignResultFour({ 'signMan': this.signStepEmplid, 'body': this.submitAppointTaskData }).toPromise().then(async signResult => {
                  if (signResult[0]['success']) {
                    this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                    await this.lb4ApiService.updateAll('form_sign_process', { phone: this.assignPhone }, { formId: this.formid, signStep: this.step });
                    this.route.navigate([this.url], { replaceUrl: true });
                  } else {
                    this.nzSpinning = false;
                    this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                  }
                }).catch(e => {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                });
              }
            }
          } else {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.facEngineeringPhoneTip')}`);
          }
        }
        else if (this.name === "BidCreating") {
          const vendorCode = localStorage.getItem('userid').length > 7 ? localStorage.getItem('userid') : localStorage.getItem('userid').slice(0, -1);
          if (this.submitBidSaveData !== undefined) {
            if (Object.keys(this.submitBidSaveData).length === 4) {
              // 检查标单内容是否都已经填写完毕
              let submitQuantityArr = [];//已保存的标单信息
              for (const eachBidItemDetail of this.submitBidSaveData['bidItemDetail']) {
                submitQuantityArr.push(eachBidItemDetail['quantity']);
              }
              // 标单信息!==已保存的标单信息
              if (JSON.stringify(this.submitBidSaveData) !== JSON.stringify(this.bidSaveData)) {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.saveBidTip')}`);
              }
              else if (submitQuantityArr.includes("")) {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.bidQuantitySaveTip')}`);
              }
              else if (!('projectName' in this.submitBidSaveData['bidBaseInfor']) || this.submitBidSaveData['bidBaseInfor']['projectName'].length < 1) {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.bidProjectNameSaveTip')}`);
              }
              else {
                let param = {};
                if (['Common.Rejected'].includes(this.activeBtn)) {
                  param = {
                    signMan: vendorCode,
                    body: { "formId": this.formid, "status": -2, "signStep": 5 }
                  };
                }
                else {//待签核
                  param = {
                    signMan: vendorCode,
                    body: { "formId": this.formid, "status": 1, "signStep": 5 }
                  };
                }
                // 调用API提交数据
                this.formSignProcessService.sendSignResultFive(param).toPromise().then(res => {
                  if (res[0]['success']) {
                    this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                    this.route.navigate([this.url], { replaceUrl: true });
                  } else {
                    this.nzSpinning = false;
                    this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                  }
                }).catch(e => {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                });

              }
            }
            else {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.bidSubmitTip')}`);
            }
          }
          else {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.bidSubmitTip')}`);
          }
        }
        // 厂务概算制定
        else if (this.name === "Budgeting") {
          // 是否符合提交要求
          let isPass = false;
          // 标单中的信息是否符合提交要求
          let bidInfoStatus = true;
          let signStep5Arr = [];
          await this.lb4ApiService.find('form_sign_process', {
            fields: { status: true },
            where: { formId: this.formid, signStep: 5 },
          }).then(signData => {
            for (let each in signData) {
              signStep5Arr.push(signData[each]['status']);
            }
          });
          signStep5Arr = (await this.detailApplicationService.getSignStep5Arr(this.formid)).signStep5Arr;
          if (signStep5Arr.includes(-2) || signStep5Arr.includes(0)) {//如果有标单是被驳回或待制定的则要等厂商提交标单后才能提交
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.budgetingSubmitTip')}`);
          }
          else if (Object.keys(this.reviewResultStatusData).length < 2) {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.reviewResultTip')}`);
          }
          else if (this.reviewResultStatusData['status'] === 5
            || (this.reviewResultStatusData['status'] === 2 && this.reviewResultStatusData['civilRemark'] === "")
            || (this.reviewResultStatusData['status'] === 3 && this.reviewResultStatusData['electroRemark'] === "")
            || (this.reviewResultStatusData['status'] === 4 && this.reviewResultStatusData['electroRemark'] === "" && this.reviewResultStatusData['civilRemark'] === "")) {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.reviewResultRejectTip')}`);
          }
          else if (this.reviewResultStatusData['status'] > 1) {//如果是驳回
            isPass = true;
          }
          else if (JSON.stringify(this.submitBudgetSaveData) === "{}") {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.budgetSaveTip')}`);
          }
          else if (this.civilEngineering === this.electromechanical && Object.keys(this.submitBudgetSaveData).length < 2) {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.budgetingSubmitTip')}`);
          }
          else if (this.civilEngineering === this.electromechanical && this.submitBudgetSaveData['civil'] === undefined) {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.budgetSaveCivilTip')}`);
          }
          else if (this.civilEngineering === this.electromechanical && this.submitBudgetSaveData['elec'] === undefined) {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.budgetSaveElecTip')}`);
          }
          else if (JSON.stringify(this.submitActualTaskData) === "{}" || (Object.keys(this.submitActualTaskData['civilfactureData']).length < 3 && Object.keys(this.submitActualTaskData['electrofactureData']).length < 3)) {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.vendorActualTip')}`);
          }
          else if (this.civilEngineering === this.electromechanical && (Object.keys(this.submitActualTaskData['civilfactureData']).length < 3 || Object.keys(this.submitActualTaskData['electrofactureData']).length < 3)) {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.vendorActualTip')}`);
          }
          else {
            Object.keys(this.submitBudgetSaveData).forEach(async key => {
              if (Object.keys(this.submitBudgetSaveData[key]).length === 4) {
                const budgetType = key === 'civil' ? this.translateService.instant('BidCreat.civilBid') : this.translateService.instant('BidCreat.mechatronicsBid');
                let submitQuantityArr = [];//已保存的标单信息
                // 检查标单内容是否都已经填写完毕
                for (const eachBudget of this.submitBudgetSaveData[key]['bidItemDetail']) {
                  submitQuantityArr.push(eachBudget['quantity']);
                }
                // 保单信息!==已保存的标单信息
                if (JSON.stringify(this.submitBudgetSaveData[key]) !== JSON.stringify(this.budgetSaveData[key])) {
                  this.nzSpinning = false;
                  bidInfoStatus = false;
                  this.message.create('error', `${budgetType} : ${this.translateService.instant('CommonMessageTip.saveBidTip')}`);
                }
                else if (submitQuantityArr.includes("")) {
                  this.nzSpinning = false;
                  bidInfoStatus = false;
                  this.message.create('error', `${budgetType} : ${this.translateService.instant('CommonMessageTip.bidQuantitySaveTip')}`);
                }
                else if (!('projectName' in this.submitBudgetSaveData[key]['bidBaseInfor']) || this.submitBudgetSaveData[key]['bidBaseInfor']['projectName'].length < 1) {
                  this.nzSpinning = false;
                  bidInfoStatus = false;
                  this.message.create('error', `${budgetType} : ${this.translateService.instant('CommonMessageTip.bidProjectNameSaveTip')}`);
                }
                else if (this.submitBudgetSaveData[key]['bidBaseInfor']['customerName'] === "") {
                  this.nzSpinning = false;
                  bidInfoStatus = false;
                  this.message.create('error', `${budgetType} : ${this.translateService.instant('CommonMessageTip.bidCustomerNameTip')}`);
                }
                else if (!(this.submitBudgetSaveData[key]['bidBaseInfor']['monthlyDay']) || !(this.submitBudgetSaveData[key]['bidBaseInfor']['warrantyPeriod']) || !(this.submitBudgetSaveData[key]['bidBaseInfor']['deliveryCycle']) || !(this.submitBudgetSaveData[key]['bidBaseInfor']['quoteInday'])) {
                  this.nzSpinning = false;
                  bidInfoStatus = false;
                  this.message.create('error', `${budgetType} : ${this.translateService.instant('CommonMessageTip.bidRemarkTip')}`);
                }
              }
            });
            if (bidInfoStatus) {
              if (this.reviewResultStatusData['projectCategory'] === undefined) {
                this.nzSpinning = false;
                this.message.create('error', ` ${this.translateService.instant('CommonMessageTip.selectProjectCategoryTip')}`);
              }
              else {
                isPass = true;
              }
            }
            else {
              isPass = false;
            }

          }
          if (isPass) {
            // 调用API提交数据
            let params = {
              signMan: this.signStepEmplid,
              body: this.reviewResultStatusData
            }
            console.log("reviewResultStatusData", this.reviewResultStatusData);

            if (['Common.ToBeCreated'].includes(this.activeBtn)) {
              await this.formSignProcessService.sendSignResultSix(params).toPromise().then(async res => {
                if (res[0]['success']) {
                  this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                  // update 厂商实际查看现场时间到DB
                  if (this.reviewResultStatusData['status'] === 1) {
                    if (this.civilEngineering) {
                      await this.lb4ApiService.updateAll(
                        'appointment_manufacturer_time',
                        { actualViewData: this.submitActualTaskData['civilfactureData']['actualViewData'] },
                        { formId: this.formid, signStep: this.step, civilOrElectro: 0 }
                      ).catch(e => {
                        this.nzSpinning = false;
                        console.log('error', `更新civilOrElectro失败:${JSON.stringify(e)}`);
                      });
                    }
                    if (this.electromechanical) {
                      await this.lb4ApiService.updateAll(
                        'appointment_manufacturer_time',
                        { actualViewData: this.submitActualTaskData['electrofactureData']['actualViewData'] },
                        { formId: this.formid, signStep: this.step, civilOrElectro: 1 }
                      ).catch(e => {
                        this.nzSpinning = false;
                        console.log('error', `更新civilOrElectro失败:${JSON.stringify(e)}`);
                      });
                    }
                  }
                  this.route.navigate([this.url], { replaceUrl: true });
                } else {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                }
              }).catch(e => {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
              });
            }
            if (['Common.Rejected'].includes(this.activeBtn)) {
              await this.formSignProcessService.sendSignResultSixRe(params).toPromise().then(res => {
                if (res[0]['success']) {
                  this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                  // update 厂商实际查看现场时间到DB
                  if (this.reviewResultStatusData['status'] === 1) {
                    if (this.civilEngineering) {
                      this.lb4ApiService.updateAll('appointment_manufacturer_time', { actualViewData: this.submitActualTaskData['civilfactureData']['actualViewData'] }, { formId: this.formid, signStep: this.step, civilOrElectro: 0 });
                    }
                    if (this.electromechanical) {
                      this.lb4ApiService.updateAll('appointment_manufacturer_time', { actualViewData: this.submitActualTaskData['electrofactureData']['actualViewData'] }, { formId: this.formid, signStep: this.step, civilOrElectro: 1 });
                    }
                  }
                  this.route.navigate([this.url], { replaceUrl: true });
                } else {
                  this.nzSpinning = false;
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
                }
              }).catch(e => {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
              });
            }

          }
        }
        // 询价
        else if (this.name === "FacAssInquiry" && this.activeBtn === "Common.INQUIRY") {
          if (this.submitQuotationInfo["quote"] === undefined
            || ((this.civilEngineering && this.submitQuotationInfo['civilQuotAttach'] === undefined)
              || (this.electromechanical && this.submitQuotationInfo['electroQuotAttach'] === undefined))
            || (this.civilEngineering === this.electromechanical && (Object.keys(this.submitQuotationInfo).length !== 3
              || Object.keys(this.submitQuotationInfo["quote"]["formQuotation"]).length !== 3))) {
            this.nzSpinning = false;
            this.message.create('error', `${this.translateService.instant('CommonMessageTip.quotationTip')}`);
          }
          else {
            this.submitQuotationInfo["quote"]["signData"] = {
              "formId": this.formid, "status": 1, "remark": "", "signStep": Number(this.step)
            }
            this.formSignProcessService.sendAssistantInquiry({ "signMan": this.signStepEmplid, "body": this.submitQuotationInfo }).toPromise().then(res => {
              if (res[0]['success']) {
                this.message.create('success', `${this.translateService.instant('CommonMessageTip.submitSucceeded')}`);
                this.nzSpinning = false;
                this.route.navigate([this.url], { replaceUrl: true });
              } else {
                this.nzSpinning = false;
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
              }
            }).catch(e => {
              this.nzSpinning = false;
              this.message.create('error', `${this.translateService.instant('CommonMessageTip.submitFailed')}`);
            });
          }
        }
      }
      // 重新指派
      else if (this.editBtnName === "Common.Reassign") {//重新指派时,只有选择厂商可以重新选择
        let signStepArr = await this.lb4ApiService.find(
          'form_sign_process',
          {
            order: 'signStep DESC',
            where: { version: this.maxVersionNum, formId: this.formid }
          }
        );
        // 如果单据signStep>=6,即单据到 预约厂商&概算--厂务概算制定 ,则不能再重新指派厂务工程师和厂商
        if (signStepArr[0]['signStep'] >= 6) {
          this.message.create('error', `${this.translateService.instant('CommonMessageTip.cannotReassignTip')}`);
        }
        else {
          this.editBtnName = "Common.Submit";
          this.taskAssignEdictStatus = true;
          this.engineerTaskAssignEdictStatus = signStepArr[0]['signStep'] <= 4 ? false : true;//厂务课级签核中的选择厂务工程师部分是否可编辑,step<=4<时可编辑
          this.vendorTaskAssignEdictStatus = signStepArr[0]['signStep'] <= 5 ? false : true;//厂务课级签核中的选择厂商部分是否可编辑,step<=5时可编辑
          this.taskAssignDisabled = true;

          //用户点击重新指派时，此单子其他人不能做任何编辑
          await this.lb4ApiService.updateAll('form_head', { isEdit: 1, editor: this.signStepEmplid }, { formId: this.formid });
        }
      }
      // 提交:this.editBtnName = "提交";
    } else {
      this.confirmModal = this.modal.confirm({
        // nzTitle: '取消后,页面的数据都会丢失'
        nzContent: `${this.translateService.instant('CommonMessageTip.reassignCannotEditTip')}`,
        nzOnOk: () =>
          new Promise((resolve, reject) => {
            const crypto = window.crypto.getRandomValues(new Uint8Array(1))[0] * 0.001;//符合密码学要求的安全的随机值
            setTimeout(crypto > 0.5 ? resolve : reject, 1);
          })
      });
    }
  }
  createMessage(type: string, value: string): void {
    this.message.create(type, value);
  }

  // 获取初始化的单据详情
  async getInitDeteailData() {
    let result;
    if (this.name === "MyDoc") {
      let body = {
        "status": this.num,
        "emplid": this.signStepEmplid,
        "queryValue": this.formid
      }
      result = await this.vwFindMyFormService.findMyFormData(body);
    }
    // 申请单位签核 厂务签核 预约厂商 厂商标单制定 厂务概算制定 厂务助理询价
    if (["ApplyingUnit", "FacilityApproval", "VendorAppointment", "BidCreating", "Budgeting", "FacAssInquiry", "BudgetsApproval", "projectdetails"].includes(this.name)) {
      let param = {
        "status": this.num,
        "emplid": this.name === "BidCreating" && this.url.includes('manufacturerbidconfig') ? localStorage.getItem('userid').length > 7 ? localStorage.getItem('userid') : localStorage.getItem('userid').slice(0, -1) : this.signStepEmplid,
        "signStep": this.step,
        "queryValue": this.formid
      }
      result = await this.vwFindSigndata.findSignData({ body: param }).toPromise();
    }
    // 基础数据
    this.DetailData['formId'] = this.formid;
    if (JSON.stringify(result[0]) !== "{}") {
      Object.keys(result[0][this.formid]['formApplyDetail']).forEach(key => {
        this.DetailData[key] = result[0][this.formid]['formApplyDetail'][key];
      });
      Object.keys(result[0][this.formid]['applicant']).forEach(key => {
        this.DetailData[key] = result[0][this.formid]['applicant'][key];
      });
      this.DetailData["emplid"] = this.DetailData["name"] + ' / ' + this.DetailData["emplid"];
      this.civilEngineering = Boolean(this.DetailData['civilEngineering']);
      this.electromechanical = Boolean(this.DetailData['electromechanical']);
      this.getProjectCategory = this.DetailData['projectCategory'] === null ? null : Number(this.DetailData['projectCategory']);
      this.projectCategory = this.getProjectCategory;
    }
    // 厂商标单制定 && this.url.includes('manufacturerbidconfig')
    if (this.name === "BidCreating") {
      //若登录者为土建厂商(vendorCode),则只显示土建的信息;若登录者为机电厂商(vendorCode),则只显示机电的信息
      const vendorCode = localStorage.getItem('userid').length > 7 ? localStorage.getItem('userid') : localStorage.getItem('userid').slice(0, -1);
      await this.lb4ApiService.find('vendor_info', { where: { "vendorCode": vendorCode } }).then(res => {
        const vendorInfo = res[0];
        if (["土建", "Civil"].includes(vendorInfo['type'])) {
          this.electromechanical = false;
        }
        else {
          this.civilEngineering = false;
        }
      })
        .catch((err: any) => {
          console.log("err", err);
        });
    }
  }

  submitDataEvent(event) {
    this.edictData = event;
    this.DetailData['electromechanical'] = this.edictData['electromechanical'];
    this.DetailData['civilEngineering'] = this.edictData['civilEngineering'];
    this.DetailData['description'] = this.edictData['description'];
    this.civilEngineering = Boolean(this.DetailData['civilEngineering']);
    this.electromechanical = Boolean(this.DetailData['electromechanical']);
  }

  // 点击取消或返回按钮
  async cancelOrReturnFn(key: string) {
    if (key === "cancel") {
      if (this.name === "FacAssInquiry") {
        let param = {
          "formId": this.formid,
          "status": -4,
          "remark": "",
          "signStep": Number(this.step)
        };
        this.confirmModal = this.modal.confirm({
          nzContent: this.translateService.instant('CommonMessageTip.cancelDocTip'),
          nzOnOk: () =>
            new Promise(async (resolve, reject) => {
              const crypto = window.crypto.getRandomValues(new Uint8Array(1))[0] * 0.001;//符合密码学要求的安全的随机值
              setTimeout(crypto > 0.5 ? resolve : reject, 1);
              await this.formSignProcessService.assistantCancelForm({ signMan: this.signStepEmplid, body: param }).toPromise().then(assistantRes => {
                if (assistantRes[0]['success']) {
                  this.message.create('success', `${this.translateService.instant('CommonMessageTip.canceledSucceeded')}`);
                  this.route.navigate([this.url], { replaceUrl: true });
                } else {
                  this.message.create('error', `${this.translateService.instant('CommonMessageTip.canceledFialed')}`);
                }
              }).catch(e => {
                this.message.create('error', `${this.translateService.instant('CommonMessageTip.canceledFialed')}`);
              });
            }).catch((e) => console.log(e))
        });
      }
      else {
        this.isCancel = true;
        // await this.formSignProcessService.updateSignStatus({ formId: this.formid }).toPromise().then(updateResult1 => {
        //   if (updateResult1[0]['success']) {
        //     this.message.create('success', `${this.translateService.instant('CommonMessageTip.canceledSucceeded')}`);
        //     this.route.navigate([this.url], { replaceUrl: true });
        //   } else {
        //     this.message.create('error', `${this.translateService.instant('CommonMessageTip.canceledFialed')}`);
        //   }
        // }).catch(e => {
        //   this.message.create('error', `${this.translateService.instant('CommonMessageTip.canceledFialed')}`);
        // });
        // this.isCancel = false;
      }
    }
    else {
      this.route.navigate([this.url], { replaceUrl: true });
    }
  }
  // 取消-取消单据
  handleCancelCancel() {
    this.isCancel = false;
  }
  // 确定-取消单据
  async handleCancelOk() {
    await this.formSignProcessService.updateSignStatus({ body: { formId: this.formid, remark: this.cancelReason } }).toPromise().then(updateResult1 => {
      if (updateResult1[0]['success']) {
        this.message.create('success', `${this.translateService.instant('CommonMessageTip.canceledSucceeded')}`);
        this.route.navigate([this.url], { replaceUrl: true });
      } else {
        this.message.create('error', `${this.translateService.instant('CommonMessageTip.canceledFialed')}`);
      }
    }).catch(e => {
      this.message.create('error', `${this.translateService.instant('CommonMessageTip.canceledFialed')}`);
    });
    this.isCancel = false;
  }
  async showModal(currentVersion: number) {
    this.modalTitle = `${this.translateService.instant('DetailInfo.HistoricalData')}：${this.translateService.instant('Common.VERSION')}${currentVersion}`;
    // 查看历史数据时不能删除历史记录的现况区域照片和上传需求方案
    this.nzShowUploadList.showRemoveIcon = false;

    let formApplyDetail = await this.lb4ApiService.find('form_apply_detail', { where: { formId: this.formid, version: currentVersion } });
    let formHeadResult = await this.lb4ApiService.find('form_head', { where: { formId: this.formid, version: currentVersion } });
    if (formApplyDetail.length > 0 && formHeadResult.length > 0) {
      Object.keys(formApplyDetail[0]).forEach(key => {
        this.historyDetailData[key] = formApplyDetail[0][key];
      });
      Object.keys(formHeadResult[0]).forEach(key => {
        if (key === 'applicantId') {
          this.historyDetailData['emplid'] = formHeadResult[0][key];
        }
        this.historyDetailData[key] = formHeadResult[0][key];
      });
    }
    if (this.historyDetailData['electromechanical'] === 1) {
      this.historyElectromechanical = true;
    }
    if (this.historyDetailData['civilEngineering'] === 1) {
      this.historyCiviEngineering = true
    }
    this.isVisible = true;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  async getInintVersins() {
    let result = await this.lb4ApiService.find('form_apply_detail', { where: { formId: this.formid } });
    if (result.length > 0) {
      result.forEach(element => {
        if (element['version'] !== this.DetailData['version']) {
          this.versionArr.push(element['version']);
        }
      })
    }
  }

  // 审核结果 step 1,2,3
  radioChangEmitter(event) {
    this.assignStatusData = {
      "formId": this.formid,
      "status": event["status"],
      "emplid": this.signStepEmplid,
      "remark": event["remark"],
      "signStep": this.step
    }
    if (this.name === "FacilityApproval") {
      delete this.assignStatusData["emplid"];
      // 如果审核结果选择的是驳回
      if (event["status"] === 2) {
        //厂务工程师后面的内容只能看不能勾选
        this.isEdit = false;//工程分类不可选
        this.vendorTaskAssignEdictStatus = true;//工程分类明细,派单厂务工程师,选择厂商不可选
        this.taskAssignDisabled = true;//工程分类明细,派单厂务工程师,选择厂商可选
      }
      // 如果审核结果选择的是同意
      if (event["status"] === 1) {
        this.assignStatusData['remark'] = this.assignStatusData['remark'] ?? "";
        this.isEdit = true;//工程分类可选
        this.vendorTaskAssignEdictStatus = false;//工程分类明细,派单厂务工程师,选择厂商可选
        this.taskAssignDisabled = false;//工程分类明细,派单厂务工程师,选择厂商可选
      }
    }
  }

  // 专案分类
  sendProjectCategory(event: number) {
    this.projectCategory = event;
    this.reviewResultStatusData['projectCategory'] = event;
  }

  // 审核结果--标单
  reviewResultChangEmitter(event: object) {
    /* 
      step6:
      厂务概算制定--待制定 || 已驳回
      status:1--同意;2--驳回土建;3--驳回机电;4--驳回机电和土建
      待制定/已驳回同意:{"formId":"E220808033","status":1,"signStep":6,"projectCategory":1,"remark":"我同意的"}
      驳回土建:{ 'status': 2, 'civilRemark': this.civilRemark }
      驳回机电:{ 'status': 3, 'electroRemark': this.electroRemark }
      驳回土建和机电:{ 'status': 4, 'civilRemark': this.civilRemark, 'electroRemark': this.electroRemark }
      step>6:
      同意:{"formId":"E220315001","status":1,"remark":"通过","signStep":9}
      驳回:{"formId":"E220315001","status":2,"remark":"通过","signStep":9}
    */
    this.reviewResultIsReject = event['status'] === 1 ? false : true;
    if (Number(this.step) === 6) {
      // 审核结果:同意
      if (event['status'] === 1 && this.reviewResultStatusData['projectCategory'] >= 0) {
        const resultData = {
          "formId": this.formid,
          "status": event["status"],
          "remark": event['remark'] ?? "",
          "signStep": Number(this.step)
        };
        // 如果是在厂务概算制定中,要...this.reviewResultStatusData,因为此处要传专案分类this.reviewResultStatusData['projectCategory']
        this.reviewResultStatusData = { ...this.reviewResultStatusData, ...resultData };
        delete this.reviewResultStatusData['civilRemark'];
        delete this.reviewResultStatusData['electroRemark'];
      }
      // 审核结果:驳回
      else {
        // 如果驳回的是土建标单或土建概算
        const resultData = {
          "formId": this.formid,
          "status": event["status"],
          "civilRemark": event['civilRemark'] ?? "",
          "electroRemark": event['electroRemark'] ?? "",
          "signStep": Number(this.step)
        };
        this.reviewResultStatusData = { ...this.reviewResultStatusData, ...resultData };
      }
    }
    else {
      if (event['status'] === 1) {//同意
        this.reviewResultStatusData = {
          "formId": this.formid,
          "status": event["status"],
          "remark": event['remark'] ?? "",
          "signStep": Number(this.step)
        };
      }
      else {
        this.reviewResultStatusData = {
          "formId": this.formid,
          "status": event["status"],
          "remark": event["remark"] ?? "",
          "signStep": Number(this.step)
        };
      }
    }
  }

  submitTaskAssignDataEvent(event: Object) {
    this.submitTaskAssignData = event;
  }

  // 预约厂商信息
  submitAppointTaskDataEvent(event: Object) {
    this.submitAppointTaskData = event;
    this.submitAppointTaskData['signData'] = {
      "formId": this.formid,
      "status": 1,
      "remark": "",
      "signStep": Number(this.step)
    }
  }

  // 厂商实际到场信息
  submitActualTaskDataEvent(event: Object) {
    this.submitActualTaskData = event;
  }

  // 厂商标单制定--保存
  getSubmitBidSaveData(obj: Object) {
    // { "submitBidSaveData": submitBidSaveData, "bidSaveData": this.bidSaveData,"bidType": type, }
    this.bidSaveData = obj['bidSaveData'];
    this.submitBidSaveData = obj['submitBidSaveData'];
  }
  // 厂务概算制定--保存
  getSubmitBudgetSaveData(obj: BidInfo) {
    Object.keys(obj).forEach(key => {
      if (Object.keys(obj[key]).length > 0) {
        this.submitBudgetSaveData[key] = obj[key]['submitBidSaveData'];
        this.budgetSaveData[key] = obj[key]['bidSaveData'];
      }
    });
  }


  // 报价单上传--报价金额
  quotationAmount(obj: object) {
    const data = {
      "quote": {
        "formQuotation": {}
      }
    };
    Object.keys(obj).forEach(key => {
      data.quote.formQuotation[key] = obj[key];
    });
    this.submitQuotationInfo["quote"] = data.quote;
    this.submitQuotationInfo["quote"]["formQuotation"]["formId"] = this.formid;
    this.submitQuotationInfo["quote"]["formQuotation"]['civilQuotAmount'] = data["quote"]["formQuotation"]['civilQuotAmount'] === undefined ? null : data["quote"]["formQuotation"]['civilQuotAmount'];
    this.submitQuotationInfo["quote"]["formQuotation"]['electroQuotAmount'] = data["quote"]["formQuotation"]['electroQuotAmount'] === undefined ? null : data["quote"]["formQuotation"]['electroQuotAmount'];
  }

  // 报价单上传--报价单上传
  quotationAttach(obj: object) {
    Object.keys(obj).forEach(key => {
      if (obj[key].length === 0) {
        delete this.submitQuotationInfo[key];
      }
      else {
        this.submitQuotationInfo[key] = obj[key];
      }
    });

  }

  // 挂帐部门 预算编码 厂别
  budgetCodeAndCreditDepartment(obj: object) {
    this.formBudgetCharge = obj;
  }

  // 获取在预约厂商中填写的派单厂务工程师联系方式
  async getDBAssignPhone() {
    let status = await this.lb4ApiService.find(
      'form_sign_process',
      {
        "order": 'version DESC',
        where: { "formId": this.formid, "signStep": 4 }, fields: { status: true }
      });
    if (status.length > 0) {
      if (status[0]["status"] === 1) {
        let phone = await this.lb4ApiService.find(
          'form_sign_process',
          {
            where: { "formId": this.formid, "signStep": 4, "status": 1, "version": this.maxVersionNum }, fields: { phone: true }
          });
        if (phone.length > 0) {
          this.getAssignPhone = phone[0]['phone'];
        } else {
          this.getAssignPhone = '';
        }
      }
    }
  }
  // 获取DB中的预算编码和挂账部门
  async getInitInquotationInfo() {
    await this.lb4ApiService.find('form_budget_charge',
      {
        "order": 'version DESC',
        "where": { "formId": this.formid, "signStep": Number(this.step) }, fields: { budgetCode: true, creditDepartment: true, plant: true }
      }).then(res => {
        this.getFormBudgetCharge = res[0];
      });
  }

  dataComparison(DetailData, edictData) {
    let result = [];
    if (edictData != undefined) {
      DetailData.map(detailDataItem => {
        edictData.map(edictDataItem => {
          if (detailDataItem.indexOf(edictDataItem['name']) > -1) {
            result.push(detailDataItem)
          }
        })
      })
    } else {
      return JSON.stringify(DetailData);
    }
    return JSON.stringify(result);
  }

  //离开页此当前组件的时候触发
  async ngOnDestroy(): Promise<void> {
    let formHead = await this.lb4ApiService.find('form_head', { where: { formId: this.formid } });
    if (formHead[0]['editor'] === this.signStepEmplid) {
      await this.lb4ApiService.updateAll('form_head', { isEdit: 0 }, { formId: this.formid });
    }
  }
}

